import { Chip, Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { credentialFailureMessage, credentialStatusLabel, credentialStatusTooltip, credentialStatusVariant, isAutomatedCredential } from './credentialStatus';

/**
 * One-line credential state for a utility row on property details.
 *
 * Shows the masked username the API returns and nothing more - no password, no reveal, no request
 * that could produce one. `isVisible` is a convenience for the caller; the real gate is the API's
 * PmRegularOrHigher, which pins a customer to their own company.
 */
export const UtilityCredentialStatusLine = _ref => {
  let credential = _ref.credential,
    isVisible = _ref.isVisible,
    unavailable = _ref.unavailable;
  if (!isVisible) return null;

  // A failed lookup leaves an empty list, which is indistinguishable from a property that genuinely
  // has no credentials. Saying "none saved" during an outage sends an operator to create one that
  // may already exist.
  if (unavailable) {
    return /*#__PURE__*/React.createElement(Stack, {
      direction: "row",
      spacing: 1,
      alignItems: "center",
      sx: {
        marginTop: '4px'
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, "Credential state unavailable"));
  }
  if (!credential) {
    return /*#__PURE__*/React.createElement(Stack, {
      direction: "row",
      spacing: 1,
      alignItems: "center",
      sx: {
        marginTop: '4px'
      }
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: credentialStatusTooltip(null),
      placement: "top",
      arrow: true
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      tabIndex: 0
    }, "No portal credentials saved")));
  }
  const failure = credentialFailureMessage(credential);
  return /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    spacing: 1,
    alignItems: "center",
    sx: {
      marginTop: '4px'
    },
    flexWrap: "wrap"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: credentialStatusTooltip(credential, {
      isAutomated: isAutomatedCredential(credential)
    }),
    placement: "top",
    arrow: true
  }, /*#__PURE__*/React.createElement(Chip, {
    tabIndex: 0,
    size: "small",
    label: credentialStatusLabel(credential),
    variant: credentialStatusVariant(credential)
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, credential.usernameHint), failure ? /*#__PURE__*/React.createElement(Tooltip, {
    title: failure,
    placement: "top"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, "Needs attention")) : null);
};